@use 'src/globals/main';

pn-text-link {
  display: inline;
}

pn-text-link .pn-text-link {
  border-radius: 0.25em;
  color: main.$blue700;
  font-weight: 500;
  text-decoration: underline;
  font-size: 1em;

  @include main.pn-transition('color, outline-color, text-decoration-color');
  @include main.pn-focus;

  &:hover {
    color: main.$blue900;
    text-decoration-color: main.$blue900;
  }

  &[data-icon] {
    display: inline-flex;
    gap: 0.25em;
    align-items: center;
    text-decoration-color: transparent;
    padding: 0.1em;
    border-radius: 0.5em;

    .pn-icon-svg path {
      fill: main.$blue700;
    }

    &:hover {
      text-decoration-color: main.$blue900;
    }

    &:hover,
    &:focus-visible {
      .pn-icon-svg path {
        fill: main.$blue900;
      }
    }

    &[data-icon-left] {
      flex-direction: row-reverse;
    }
  }

  &[data-light] {
    color: main.$white;
    &:focus-visible {
      @include main.pn-focus-visible(main.$white);
    }
    &:hover {
      text-decoration-color: main.$white;
    }
    &[data-icon] pn-icon .pn-icon-svg path {
      fill: main.$white;
    }
  }
}
